import React, { useState } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AllocationProfileViewDialog from "./AllocationProfileViewDialog";

function AllocationProfileCellWithView({ value, allocationProfiles }) {
  const [viewDialogOpen, setViewDialogOpen] = useState(false);

  const found = allocationProfiles.find((p) => p.profile_ndx === value);

  const handleViewClick = (e) => {
    e.stopPropagation(); // Prevent cell selection
    setViewDialogOpen(true);
  };

  if (!found) {
    return (
      <Typography
        sx={{
          fontStyle: "italic",
          color: "text.secondary",
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        No Allocation Profile Selected
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      }}
    >
      <Typography
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          minWidth: 0, // Allow text to truncate
        }}
      >
        {found.profile_name}
      </Typography>

      <Tooltip title="View allocation profile details">
        <IconButton
          size="small"
          onClick={handleViewClick}
          sx={{
            ml: 1,
            opacity: 0.7,
            "&:hover": {
              opacity: 1,
              backgroundColor: "action.hover",
            },
          }}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <AllocationProfileViewDialog
        open={viewDialogOpen}
        onClose={() => setViewDialogOpen(false)}
        profile={found}
      />
    </Box>
  );
}

export default AllocationProfileCellWithView;
